import { styled } from '@mui/material/styles'

export const StyledSpan = styled('span', {
  shouldForwardProp: (prop) => prop !== 'fontWeight',
})<{
  fontWeight: string | number
}>(({ fontWeight }) => ({
  fontSize: 14,
  ...(fontWeight && {
    fontWeight: fontWeight,
  }),
}))
